import { render, staticRenderFns } from "./ModalRoomGalery.vue?vue&type=template&id=03ae20c6&"
import script from "./ModalRoomGalery.vue?vue&type=script&lang=js&"
export * from "./ModalRoomGalery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports